// Stitch Your Dash - Sewing Tools & Creative DIY Supplies
// Modern DIY/craft e-commerce store

// ============================================
// SITE IMAGES - Cozy Creative Workspace Theme
// ============================================
export const siteImages = {
  // Hero & main banners
  heroMain: 'https://images.pexels.com/photos/33989158/pexels-photo-33989158.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200',
  heroSecondary: 'https://images.pexels.com/photos/34908665/pexels-photo-34908665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200',
  heroWorkspace: 'https://images.unsplash.com/photo-1622825312256-fec995a8bbdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',

  // Section backgrounds
  ctaBackground: 'https://images.pexels.com/photos/15470481/pexels-photo-15470481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
  featuredBackground: 'https://images.unsplash.com/photo-1562561568-e1ab23be103e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  inspirationBg: 'https://images.pexels.com/photos/6461502/pexels-photo-6461502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',

  // Page banners
  shopBanner: 'https://images.pexels.com/photos/34908665/pexels-photo-34908665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1920',
  aboutBanner: 'https://images.unsplash.com/photo-1562561568-e1ab23be103e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  contactBanner: 'https://images.pexels.com/photos/15470481/pexels-photo-15470481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1920',
  returnsBanner: 'https://images.pexels.com/photos/6461502/pexels-photo-6461502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1920',
  productBanner: 'https://images.unsplash.com/photo-1622825312256-fec995a8bbdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',

  // Inspiration tiles
  inspirationA: 'https://images.unsplash.com/photo-1562561568-e1ab23be103e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  inspirationB: 'https://images.pexels.com/photos/15470481/pexels-photo-15470481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800',
  inspirationC: 'https://images.pexels.com/photos/6461502/pexels-photo-6461502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800',

  // Misc
  sewingMachine: 'https://images.pexels.com/photos/33989158/pexels-photo-33989158.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=800',
  threadSpools: 'https://images.unsplash.com/photo-1562561568-e1ab23be103e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
};

// ============================================
// PRODUCT IMAGES - Sewing Tools & Gadgets
// ============================================
const productImages = {
  cuttingMat: 'https://files.ekmcdn.com/5f5d14/images/eps-a3-self-healing-cutting-mat-1652-p.png',
  fabricShears: 'https://m.media-amazon.com/images/I/71lco5c6P+L.jpg',
  presserFootKit: 'https://m.media-amazon.com/images/I/61LD0V744PL._AC_UF894,1000_QL80_.jpg',
  patternRuler: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyw6d0aMhM4kblm-kcFmE_ooxLrp1SESJX-A&s',
  repairStitchTool: 'https://m.media-amazon.com/images/I/71XaE4uQkWL.jpg',
  sewingClips: 'https://m.media-amazon.com/images/I/81qY8+8-hvL._AC_UF894,1000_QL80_.jpg',
  miniSteamIron: 'https://www.empressmills.co.uk/media/catalog/product/cache/a1bef50f9ffb0e9b68c20cfc7a6e87c1/p/r/prym_mini_steam_iron_-_p611916_-_5.jpg',
  storageBag: 'https://m.media-amazon.com/images/I/71xpVrqw59L.jpg',
  computerizedSewingMachine: 'https://s.alicdn.com/@sc04/kf/He0da971cf5424095a6ee9ab861592a40u.png_960x960q80.jpg',
  embroideryMachine: 'https://www.naehpark.com/thumbnail/83/e5/81/1699945755/janome-memory-craft-550e-limited-edition_1280x1280.jpg',
  quiltingStation: 'https://www.naehpark.com/thumbnail/0c/7a/db/1700143531/pfaff-expression-710-special-edition-front-_1280x1280.jpg?ts=1718921575',
};

export const SHIPPING_NOTICE = 'We ship to USA only';
export const SHIPPING_COUNTRIES = ['US'];
export const CURRENCY = 'USD';
export const COUNTRY_OF_ORIGIN = 'United States';

// Contact Info - Stitch Your Dash
export const CONTACT_INFO = {
  phone: '(833) 930-3855',
  email: 'support@stitchyourdash.com',
  address: {
    street: '1634 TARA CT',
    city: 'LANCASTER',
    state: 'CA',
    zip: '93535',
    country: 'United States'
  },
  corporateName: 'LP Capital Holdings LLC'
};

// Brand Info
export const BRAND_INFO = {
  name: 'Stitch Your Dash',
  tagline: 'Sewing Tools & Creative DIY Supplies',
  domain: 'stitchyourdash.com',
  // Card statement billing descriptor (as it appears on cardholder statements)
  billingDescriptor: 'STITCHYOURDASH.COM'
};

// Accepted Payment Methods (Discover is NOT accepted)
export const ACCEPTED_CARDS = ['Visa', 'Mastercard', 'American Express'];
export const ACCEPTED_CARDS_LABEL = 'Visa, Mastercard, and American Express';

// Return Address (kept the same)
export const RETURN_ADDRESS = {
  street: '555 Remington Blvd., Ste B',
  city: 'Bolingbrook',
  state: 'IL',
  zip: '60440',
  country: 'USA'
};

// Shipping Information
export const SHIPPING_INFO = {
  domestic: {
    standard: {
      name: 'Standard Shipping (USPS)',
      price: 9.95,
      freeThreshold: 99,
      deliveryTime: '5-7 business days',
      carrier: 'USPS First Class / Priority Mail'
    },
    express: {
      name: 'Express Shipping (USPS Priority Express)',
      price: 19.95,
      deliveryTime: '2-3 business days',
      carrier: 'USPS Priority Mail Express'
    }
  },
  processingTime: 'Orders placed before 3 PM EST are processed same day. Weekend orders are processed on the next business day.'
};

// ============================================
// PRODUCTS (Updated with new catalog)
// ============================================
export const products = [
  {
    id: 'self-healing-cutting-mat',
    name: 'Self-Healing Cutting Mat (A3 Size)',
    slug: 'self-healing-cutting-mat',
    sku: 'SYD-001',
    price: 21.99,
    image: productImages.cuttingMat,
    category: 'quilting-tools',
    badge: 'Popular',
    description: 'Durable cutting mat with self-healing surface that protects tables and ensures precise fabric cutting for quilting and sewing.',
    features: ['Self-Healing Surface', 'A3 Size', 'Grid Markings', 'Protects Tables'],
    inStock: true
  },
  {
    id: 'professional-tailor-fabric-shears',
    name: 'Professional Tailor Fabric Shears',
    slug: 'professional-tailor-fabric-shears',
    sku: 'SYD-002',
    price: 26.99,
    image: productImages.fabricShears,
    category: 'fabric-scissors',
    badge: 'Best Seller',
    description: 'Heavy-duty scissors designed for smooth, precise cutting of fabric without fraying edges.',
    features: ['Heavy-Duty Steel', 'Ergonomic Handle', 'Precise Cutting', 'No Fraying'],
    inStock: true
  },
  {
    id: 'universal-presser-foot-kit',
    name: 'Universal Presser Foot Kit (32 pcs)',
    slug: 'universal-presser-foot-kit',
    sku: 'SYD-003',
    price: 34.99,
    image: productImages.presserFootKit,
    category: 'machine-accessories',
    description: 'Complete set of presser feet compatible with most sewing machines, ideal for various stitching techniques.',
    features: ['32 Pieces Included', 'Universal Fit', 'Storage Case', 'Multiple Techniques'],
    inStock: true
  },
  {
    id: 'pattern-drafting-ruler-set',
    name: 'Pattern Drafting Ruler Set',
    slug: 'pattern-drafting-ruler-set',
    sku: 'SYD-004',
    price: 17.99,
    image: productImages.patternRuler,
    category: 'pattern-making',
    description: 'Essential rulers for creating and adjusting sewing patterns with accuracy and ease.',
    features: ['Multiple Sizes', 'Clear Markings', 'Durable Plastic', 'Pattern Ready'],
    inStock: true
  },
  {
    id: 'clothing-repair-stitch-tool',
    name: 'Clothing Repair Stitch Tool',
    slug: 'clothing-repair-stitch-tool',
    sku: 'SYD-005',
    price: 12.99,
    image: productImages.repairStitchTool,
    category: 'repair-alteration',
    description: 'Quick repair tool designed for fixing seams, hems, and minor clothing adjustments without hassle.',
    features: ['Compact Design', 'Easy to Use', 'Quick Repairs', 'Battery Powered'],
    inStock: true
  },
  {
    id: 'color-sewing-clips-set',
    name: 'Color Sewing Clips Set (100 pcs)',
    slug: 'color-sewing-clips-set',
    sku: 'SYD-006',
    price: 13.99,
    image: productImages.sewingClips,
    category: 'pins-clips',
    badge: 'Popular',
    description: 'Safe and reusable clips for holding fabric layers together without damaging materials.',
    features: ['100 Clips Included', 'Multiple Colors', 'Reusable', 'Fabric-Safe'],
    inStock: true
  },
  {
    id: 'mini-steam-iron',
    name: 'Mini Steam Iron for Sewing',
    slug: 'mini-steam-iron',
    sku: 'SYD-007',
    price: 28.99,
    image: productImages.miniSteamIron,
    category: 'ironing-pressing',
    description: 'Compact steam iron perfect for pressing seams and small fabric pieces during sewing projects.',
    features: ['Compact Size', 'Steam Function', 'Quick Heat-Up', 'Portable'],
    inStock: true
  },
  {
    id: 'portable-sewing-storage-bag',
    name: 'Portable Sewing Storage Organizer Bag',
    slug: 'portable-sewing-storage-bag',
    sku: 'SYD-008',
    price: 32.99,
    image: productImages.storageBag,
    category: 'storage-bags',
    badge: 'Best Seller',
    description: 'Spacious and durable bag designed to store sewing tools and accessories neatly for home or travel.',
    features: ['Multiple Compartments', 'Durable Fabric', 'Travel-Ready', 'Spacious Storage'],
    inStock: true
  },
  {
    id: 'computerized-sewing-machine',
    name: 'Computerized Sewing Machine',
    slug: 'computerized-sewing-machine',
    sku: 'SYD-009',
    price: 833.00,
    rating: 4.8,
    views: 147,
    image: productImages.computerizedSewingMachine,
    category: 'sewing-machines',
    badge: 'Premium',
    description: 'Advanced computerized sewing machine with multiple stitch patterns, automatic needle threading, adjustable speed control, LCD display, and precision fabric handling. Ideal for experienced sewists, quilting projects, and custom garment creation.',
    features: ['Multiple Stitch Patterns', 'Automatic Needle Threading', 'Adjustable Speed Control', 'LCD Display'],
    inStock: true
  },
  {
    id: 'professional-embroidery-machine',
    name: 'Professional Embroidery Machine',
    slug: 'professional-embroidery-machine',
    sku: 'SYD-010',
    price: 629.99,
    rating: 4.7,
    views: 128,
    image: productImages.embroideryMachine,
    category: 'sewing-machines',
    badge: 'Premium',
    description: 'Professional embroidery machine designed for detailed monograms, decorative stitching, and custom embroidery work. Features multiple embroidery patterns, USB design import, and intuitive touchscreen controls.',
    features: ['Multiple Embroidery Patterns', 'USB Design Import', 'Touchscreen Controls', 'Professional Grade'],
    inStock: true
  },
  {
    id: 'ultimate-quilting-sewing-station-bundle',
    name: 'Ultimate Quilting & Sewing Station Bundle',
    slug: 'ultimate-quilting-sewing-station-bundle',
    sku: 'SYD-011',
    price: 416.39,
    rating: 4.9,
    views: 184,
    image: productImages.quiltingStation,
    category: 'sewing-furniture',
    badge: 'Premium',
    description: 'Complete sewing workstation bundle featuring a spacious crafting surface, integrated storage compartments, thread organization system, and dedicated space for sewing and quilting projects. Designed for serious hobbyists and professionals.',
    features: ['Spacious Crafting Surface', 'Integrated Storage', 'Thread Organization System', 'Quilting Ready'],
    inStock: true
  }
];

// ============================================
// CATEGORIES (8 new categories matching products)
// ============================================
export const categories = [
  {
    id: 'quilting-tools',
    name: 'Quilting Tools',
    description: 'Cutting mats, rotary tools & quilting essentials',
    image: productImages.cuttingMat,
    productSlug: 'self-healing-cutting-mat'
  },
  {
    id: 'fabric-scissors',
    name: 'Fabric Scissors',
    description: 'Professional shears for clean, precise cuts',
    image: productImages.fabricShears,
    productSlug: 'professional-tailor-fabric-shears'
  },
  {
    id: 'machine-accessories',
    name: 'Sewing Machine Accessories',
    description: 'Presser feet, bobbins & sewing extras',
    image: productImages.presserFootKit,
    productSlug: 'universal-presser-foot-kit'
  },
  {
    id: 'pattern-making',
    name: 'Pattern Making Tools',
    description: 'Drafting rulers & pattern essentials',
    image: productImages.patternRuler,
    productSlug: 'pattern-drafting-ruler-set'
  },
  {
    id: 'repair-alteration',
    name: 'Repair & Alteration Tools',
    description: 'Quick fixes for seams, hems & repairs',
    image: productImages.repairStitchTool,
    productSlug: 'clothing-repair-stitch-tool'
  },
  {
    id: 'pins-clips',
    name: 'Pins & Clips',
    description: 'Fabric-safe holders for every project',
    image: productImages.sewingClips,
    productSlug: 'color-sewing-clips-set'
  },
  {
    id: 'ironing-pressing',
    name: 'Ironing & Pressing Tools',
    description: 'Compact irons & pressing helpers',
    image: productImages.miniSteamIron,
    productSlug: 'mini-steam-iron'
  },
  {
    id: 'storage-bags',
    name: 'Sewing Storage Bags',
    description: 'Organizers to keep tools tidy & travel-ready',
    image: productImages.storageBag,
    productSlug: 'portable-sewing-storage-bag'
  },
  {
    id: 'sewing-machines',
    name: 'Sewing Machines',
    description: 'Computerized & embroidery machines for every project',
    image: productImages.computerizedSewingMachine,
    productSlug: 'computerized-sewing-machine'
  },
  {
    id: 'sewing-furniture',
    name: 'Sewing Furniture & Workstations',
    description: 'Quilting stations & dedicated crafting workspaces',
    image: productImages.quiltingStation,
    productSlug: 'ultimate-quilting-sewing-station-bundle'
  }
];

// ============================================
// TESTIMONIALS (Removed as requested)
// ============================================
export const testimonials = [];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  {
    id: 1,
    title: 'Easy to Use',
    description: 'Intuitive tools designed for crafters of all skill levels'
  },
  {
    id: 2,
    title: 'Perfect for DIY',
    description: 'Everything you need for your handmade projects'
  },
  {
    id: 3,
    title: 'Time-Saving',
    description: 'Smart gadgets that help you work faster and better'
  },
  {
    id: 4,
    title: 'Beginner Friendly',
    description: 'Start your creative journey with confidence'
  }
];

// ============================================
// STEPS (How it works)
// ============================================
export const steps = [
  {
    id: 1,
    title: 'Browse Collection',
    description: 'Explore our curated selection of premium sewing tools and craft equipment.'
  },
  {
    id: 2,
    title: 'Select Your Tools',
    description: 'Choose the perfect products for your quilting, garment making, or DIY projects.'
  },
  {
    id: 3,
    title: 'Secure Checkout',
    description: 'Complete your purchase safely with our encrypted checkout process.'
  },
  {
    id: 4,
    title: 'Fast Delivery',
    description: 'Your order arrives at your doorstep, ready to inspire your next creation.'
  }
];
